import type { CSSProperties } from "react";

export const COL: CSSProperties = { display: "flex", flexDirection: "column", gap: 10 };
export const ROW: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
};
export const LABEL: CSSProperties = {
  fontFamily: "var(--font-body)",
  fontSize: 12,
  color: "var(--d-fg-muted)",
};
export const VALUE: CSSProperties = {
  fontFamily: "var(--font-mono)",
  fontSize: 13,
  color: "var(--d-fg)",
};
export const FIELD: CSSProperties = {
  padding: "6px 10px",
  borderRadius: 8,
  border: "1px solid var(--d-line)",
  background: "var(--d-ink)",
  color: "var(--d-fg)",
  fontFamily: "var(--font-mono)",
};
export const TEXTAREA: CSSProperties = {
  ...FIELD,
  width: "100%",
  minHeight: 60,
  fontSize: 12,
};
export const BTN: CSSProperties = {
  padding: "6px 12px",
  borderRadius: 999,
  border: "none",
  background: "var(--d-violet)",
  color: "#fff",
  cursor: "pointer",
};
export const BTN_DISABLED: CSSProperties = {
  ...BTN,
  background: "var(--d-line)",
  cursor: "not-allowed",
};
export const BTN_GHOST: CSSProperties = {
  padding: "6px 12px",
  borderRadius: 999,
  background: "transparent",
  border: "1px solid var(--d-line)",
  color: "var(--d-fg)",
  cursor: "pointer",
};
export const LINK_BTN: CSSProperties = {
  background: "none",
  border: "none",
  color: "var(--d-violet)",
  cursor: "pointer",
  fontFamily: "var(--font-body)",
  fontSize: 12,
  padding: 0,
};
export const ERROR: CSSProperties = { color: "var(--d-ember)", fontSize: 12 };
export const CHECK_LABEL: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 4,
  fontSize: 12,
  color: "var(--d-fg)",
  fontFamily: "var(--font-body)",
};
